import { useState, useEffect } from "react"
import axios from "axios"

const useRukoGeodata = () => {
  const [allowNexmart, setAllowNexmart] = useState(undefined)
  const [locationData, setLocationData] = useState(undefined)
  useEffect(() => {
    axios
      .post(process.env.GATSBY_EDGE_FUNC_RUKO_NEXMART_URL, null, {
        headers: {
          "x-functions-key": process.env.GATSBY_EDGE_FUNC_TOKEN,
        },
      })
      .then((res) => {
        setAllowNexmart(res.status === 200)
        setLocationData(res.data)
      })
      .catch((error) => {
        setAllowNexmart(false)
        setLocationData(error.response.data)
      })

    return () => {
      setAllowNexmart(false)
      setLocationData(null)
    }
  }, [])
  return {
    allowNexmart,
    locationData,
  }
}

export default useRukoGeodata
